function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.086 17.5l6 6-6 6 1.414 1.414 6.707-6.707a1 1 0 000-1.414L22.5 16.086 21.086 17.5z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgArrowRightWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBjeD0iMjQiIGN5PSIyNCIgcj0iMjMiLz48cGF0aCBkPSJNMjEuMDg2IDE3LjVsNiA2LTYgNiAxLjQxNCAxLjQxNCA2LjcwNy02LjcwN2ExIDEgMCAwMDAtMS40MTRMMjIuNSAxNi4wODYgMjEuMDg2IDE3LjV6IiBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L2c+PC9zdmc+";
export { SvgArrowRightWithCircle as ReactComponent };